"use strict";

exports.__esModule = true;
exports.dataViewTable = exports.createEChartProps = exports.ReactEChartsLineChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _echartsForReact = _interopRequireDefault(require("echarts-for-react"));
require("echarts/theme/v5");
var _theme = require("../../Echarts/theme");
var _date = require("./date");
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Keeps the "v5" theme registered app-wide for charts outside this package
// that still request it; charts here use ECHARTS_THEME.

var ReactEChartsLineChart = exports.ReactEChartsLineChart = function ReactEChartsLineChart(props) {
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var width = props.width,
    height = props.height,
    echartRef = props.echartRef,
    options = props.options,
    onEvents = props.onEvents;
  return /*#__PURE__*/_react["default"].createElement(_echartsForReact["default"], {
    ref: echartRef,
    theme: modern ? _theme.ECHARTS_THEME : "v5",
    option: options,
    style: {
      height: height,
      width: width
    },
    notMerge: true,
    lazyUpdate: false,
    onEvents: onEvents
  });
};
var dataViewTable = exports.dataViewTable = function dataViewTable(series, timezone) {
  var table = '<div style="width:100%;display: table">';
  var timeHeaderName = "Time";
  var tableRowStyle = "style=\"border: 1px solid #dddddd; text-align: left; padding: 10px;\"";
  series.forEach(function (tableSeries) {
    table += "<div style=\"display: table-cell; padding: 5px\">";
    table += '<table style="width:100%;border-collapse: collapse;"><tbody>';
    table += "<tr>";
    table += "<th " + tableRowStyle + ">" + timeHeaderName + "</th>";
    table += "<th " + tableRowStyle + ">" + tableSeries.name + "</th>";
    table += "</tr>";
    tableSeries.data.forEach(function (tableData) {
      table += "<tr>";
      table += "<td " + tableRowStyle + ">" + (0, _date.formatDate)(tableData[0], timezone, "YYYY-MM-DDTHH:mm") + "</td>";
      table += "<td " + tableRowStyle + ">" + tableData[1] + "</td>";
      table += "</tr>";
    });
    table += "</tbody></table>";
    table += "</div>";
  });
  table += "</div>";
  return table;
};
var createEChartProps = exports.createEChartProps = function createEChartProps(series, timezone, translate, downloadCSVData) {
  return {
    tooltip: {
      trigger: "axis"
    },
    legend: {
      bottom: 10
    },
    toolbox: {
      show: true,
      orient: "vertical",
      right: "right",
      itemSize: 20,
      itemGap: 14,
      feature: {
        dataZoom: {
          yAxisIndex: "none"
        },
        dataView: {
          readOnly: true,
          optionToContent: function optionToContent(opt) {
            return dataViewTable(opt.series, timezone);
          }
        },
        restore: {},
        saveAsImage: {},
        myDownloadData: {
          show: true,
          title: translate("ComponentLifetimeChart.toolbox.Info", "Download as csv"),
          icon: "path://M 10 0 C 4.48 0 0 4.48 0 10 s 4.48 10 10 10 s 10 -4.48 10 -10 S 15.52 0 10 0 Z m 4.71 11.71 l -4 4 c -0.18 0.18 -0.43 0.29 -0.71 0.29 s -0.53 -0.11 -0.71 -0.29 l -4 -4 a 1.003 1.003 0 0 1 1.42 -1.42 L 9 12.59 V 5 c 0 -0.55 0.45 -1 1 -1 s 1 0.45 1 1 v 7.59 l 2.29 -2.29 c 0.18 -0.19 0.43 -0.3 0.71 -0.3 a 1.003 1.003 0 0 1 0.71 1.71 Z",
          onclick: function onclick() {
            downloadCSVData();
          }
        }
      }
    },
    xAxis: {
      type: "time",
      boundaryGap: false,
      axisLabel: {
        // Thin the labels out instead of letting adjacent time ticks overlap.
        hideOverlap: true,
        formatter: function formatter(value) {
          return (0, _date.formatDate)(value, timezone, "dd hh A");
        }
      }
    },
    yAxis: {
      type: "value",
      min: "dataMin"
    },
    series: series
  };
};